<template>
  <el-dialog
    :title="title"
    :visible="visible"
    width="50%"
    append-to-body
    @close="handleClose"
  >
    <el-form
      label-width="120px"
      :model="editForm"
      ref="editForm"
      :rules="rules"
    >
      <el-row>
        <el-form-item label="背书户" prop="customerName">
          <el-input
            size="small"
            v-model="editForm.customerName"
            auto-complete="off"
            placeholder="背书户"
          ></el-input>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="承兑人" prop="acceptorName">
          <el-input
            size="small"
            v-model="editForm.acceptorName"
            auto-complete="off"
            placeholder="承兑人"
          ></el-input>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="到期日期" prop="dueDates">
          <el-date-picker
            size="small"
            v-model="editForm.dueDates"
            type="date"
            style="width: 300px"
            value-format="yyyy-MM-dd hh:mm:ss"
            placeholder="选择日期或填写日期(yyyy-MM-dd)"
          >
          </el-date-picker>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="金额（万）" prop="faceValue">
          <el-input
            size="small"
            v-model="editForm.faceValue"
            auto-complete="off"
            placeholder="金额（万）"
          ></el-input>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="有无瑕疵" prop="flaw">
          <el-input
            size="small"
            v-model="editForm.flaw"
            auto-complete="off"
            placeholder="有无瑕疵"
          ></el-input>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="票号" prop="moneyOrderCode">
          <el-input
            size="small"
            v-model="editForm.moneyOrderCode"
            auto-complete="off"
            placeholder="票号"
          ></el-input>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="状态" prop="status">
          <el-input
            size="small"
            v-model="editForm.status"
            auto-complete="off"
            placeholder="状态"
          ></el-input>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="报价员" prop="inSalesman">
          <el-autocomplete
            size="small"
            v-model="editForm.inSalesman"
            :fetch-suggestions="querySearch"
            placeholder="输入内容自动匹配业务员"
            :trigger-on-focus="false"
            @select="handleConfirmSelectSaleman($event, editForm, 'inSalesman')"
          >
            <template slot-scope="{ item }">
              <div>
                {{ item.realName + "（" + item.dept.deptName + "）" }}
              </div>
            </template>
          </el-autocomplete>
        </el-form-item>
      </el-row>
      <!-- 0 线上 1 线下 -->
      <!-- <el-row>
        <el-form-item label="是否线上" prop="isOutLine">
          <el-checkbox
            size="small"
            :false-label="1"
            :true-label="0"
            v-model="editForm.isOutLine"
            placeholder="是否线上"
          ></el-checkbox>
        </el-form-item>
      </el-row> -->
      <el-row>
        <el-form-item label="票据类型" prop="type">
          <el-select size="small" v-model="editForm.type" placeholder="请选择">
            <el-option
              v-for="type in ticketType"
              :label="type.key"
              :value="type.value"
              :key="type.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item>
          <el-button size="small" type="primary" @click="handleSubmit"
            >确定</el-button
          >
          <el-button size="small" @click="handleClose">返回</el-button>
        </el-form-item>
      </el-row>
    </el-form>
  </el-dialog>
</template>

<script>
import { listSalesman } from "@/api/system/user";
import { addTicket } from "@/api/ticket/ticket";
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "onlineStore",
    },
  },
  data() {
    return {
      rules: {
        customerName: [
          { required: true, message: "请输入客户名称", trigger: "blur" },
        ],
        moneyOrderCode: [
          { required: true, message: "请输入票号", trigger: "blur" },
        ],
        acceptorName: [
          { required: true, message: "请输入承兑人", trigger: "blur" },
        ],
        dueDates: [
          { required: true, message: "请选择到期日期", trigger: "blur" },
        ],
        type: [{ required: true, message: "请选择票据类型", trigger: "blur" }],
      },
      ticketType: [
        { key: "全部", value: "" },
        { key: "电银", value: "电银" },
        { key: "电商", value: "电商" },
      ],
      editForm: {
        isOutLine: 0,
      },
    };
  },
  watch: {
    type: {
      handler(val) {
        console.log("val:", val);
        if (val === "onlineStore") {
          this.editForm = {
            isOutLine: 0,
          };
        } else if (val === "offlineStore") {
          this.editForm = {
            isOutLine: 1,
          };
        }
      },
      immediate: true,
    },
  },
  methods: {
    querySearch(name, call) {
      listSalesman(name)
        .then((list) => {
          call(list);
          if (list.length <= 0) {
            this.$message.warning("不存在该业务员");
          }
        })
        .catch(this.$message.error);
    },
    handleConfirmSelectSaleman(data, originData, type) {
      if (data) {
        if (type === "inSalesman") {
          originData.inSalesman = data.realName;
          originData.inSalesmanId = data.id;
        }
      }
    },
    handleSubmit() {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.editForm.preSale = "0";
          addTicket(this.editForm)
            .then(() => {
              this.$message({
                type: "success",
                message: "操作成功!",
              });
              this.$emit("confirm");
              this.handleClose();
            })
            .catch(this.$message.warning);
        }
      });
    },
    handleClose() {
      this.$emit("update:visible", false);
      this.$refs.editForm.resetFields();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/ticket/ticket-capture/add-edit/index.vue